/*
  1. Dolly /Tractors can be adhoc (i.e provided by contractors) in that case the user
  can select "/DOLLY" for dolly & "/POWER" for tractors.
  2. TRAILER_NUMBER=/BOB for bobtail flow

*/
const constants = {
  STRAIGHT_TRUCK: ["STRAIGHTTRUCK", "STRAIGHTTRUCKLG"],
  TRAILER_VALID_STATUS: ["MTY", "AVL", "CLO"],
  TRACTOR_VALID_STATUS: ["AVL"],
  DOLLY_VALID_STATUS: ["AVL"],
  ADHOC_DOLLY: "/DOLLY",
  ADHOC_TRACTOR: "/POWER",
  TRAILER_NUMBER_FOR_BOBTAIL: "/BOB",
  MAX_ADD_TRAILER_DETAILS_ALLOWED: 3,
  TRACTOR_STATUS_TO_EXCLUDE: ["PUD"],
  ERROR_MESSAGES: {
    REQUIRED:"* Required",
    DUPLICATE_TRAILER:"Duplicate trailer",
    DUPLICATE_DOLLY:"Duplicate dolly",
    VALID_TRAILER_STATUS: "Valid status 'MTY', 'AVL', 'CLO'",
    VALID_TRACTOR_STATUS: "Valid status 'AVL'",
    VALID_DOLLY_STATUS: "Valid status 'AVL'",
    VALID_DRIVER_STATUS: "Driver unavailable for dispatch",
    DRIVER_CLOCKED_IN_STATUS : "Driver not clocked-in",
  },
  TRAILER_STATUS_ALLOWED:["CLO", "MTY", "AVL", "LOA"], // do not change the order
  TRAILER_PARKING_TYPE: {
    D: 'Door',
    A: 'Yard',
  },
  ODOMETER_CONSTANTS : {
    MIN_READING_DIFFERENCE: 2,
    MAX_READING_DIFFERENCE: 600,
    MAX_READING: [9999998, 9999999],
  },
}

export default constants;